module.exports = __webpack_public_path__ + "79fef94eecac8d61ead7f6be3e48bc0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-in-the-house/Kitchen1.jpg
// module id = 3364
// module chunks = 0